import { render, staticRenderFns } from "./verify-certificate.vue?vue&type=template&id=4c8e618e&scoped=true&"
import script from "./verify-certificate.vue?vue&type=script&lang=js&"
export * from "./verify-certificate.vue?vue&type=script&lang=js&"
import style0 from "./verify-certificate.vue?vue&type=style&index=0&id=4c8e618e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e618e",
  null
  
)

export default component.exports